import PageHero from "@/components/site/PageHero";
import Reveal from "@/components/site/Reveal";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { EXHIBITION_IMAGES } from "@/data/content";
import { useT } from "@/i18n";

export default function FAQ() {
  const t = useT();
  return (
    <div data-testid="faq-page" className="bg-white">
      <PageHero
        eyebrow={t.pages.faq.eyebrow}
        title={t.pages.faq.title}
        subtitle={t.pages.faq.subtitle}
        image={EXHIBITION_IMAGES[1]}
      />

      <section className="py-24 md:py-32">
        <div className="max-w-[1000px] mx-auto px-6 md:px-10">
          <Reveal>
            <Accordion type="single" collapsible className="border-t border-black/10">
              {t.pages.faq.items.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-black/10 py-2"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left text-lg sm:text-2xl font-bold uppercase tracking-tight text-black hover:no-underline hover:text-[#C20E1A] py-6"
                  >
                    <span className="flex items-baseline gap-5 lg:gap-8 w-full pr-4">
                      <span className="text-sm font-bold text-[#C20E1A]">0{i + 1}</span>
                      <span>{f.q}</span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-base text-black/75 leading-relaxed pb-8 pt-2 pl-10 lg:pl-14 max-w-3xl">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
